import { CustomerGender, CustomerType } from "@/api-schema-enums";
import { BadgeColorVariant } from "@/components/ui/badge";
import i18next from "i18next";

export const CUSTOMER_TYPE_COLORS: Record<CustomerType, BadgeColorVariant> = {
  [CustomerType.Private]: BadgeColorVariant.Secondary,
  [CustomerType.Business]: BadgeColorVariant.Primary,
  [CustomerType.Unknown]: BadgeColorVariant.Secondary,
};

const CUSTOMER_TYPE_LABEL_KEYS: Record<CustomerType, string> = {
  [CustomerType.Private]: "masterdata:CustomerTypePrivate",
  [CustomerType.Business]: "masterdata:CustomerTypeBusiness",
  [CustomerType.Unknown]: "masterdata:CustomerTypeUnknown",
};

const GENDER_LABEL_KEYS: Record<CustomerGender, string> = {
  [CustomerGender.Male]: "masterdata:GenderMale",
  [CustomerGender.Female]: "masterdata:GenderFemale",
  [CustomerGender.Diverse]: "masterdata:GenderDiverse",
  [CustomerGender.Unknown]: "masterdata:GenderUnknown",
};

export function getCustomerTypeLabel(type: CustomerType): string {
  return i18next.t(CUSTOMER_TYPE_LABEL_KEYS[type] ?? CUSTOMER_TYPE_LABEL_KEYS[CustomerType.Unknown]);
}

export function getGenderLabel(gender: CustomerGender): string {
  return i18next.t(GENDER_LABEL_KEYS[gender] ?? GENDER_LABEL_KEYS[CustomerGender.Unknown]);
}
